var render = function render(){var _vm=this,_c=_vm._self._c;return _c('XSelect',{attrs:{"value":_vm.value,"items":_vm.items,"label":_vm.label,"item-value":!_vm.hash ? 'id' : 'hash',"item-text":"name","required":!!_vm.value && _vm.required},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }